var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more_trademark",on:{"click":_vm.toWechat}},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/more_trademark.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }